import queryString from 'query-string'
import { hp } from '../../utils'
import {
  MESSAGING_API_CLIENT_KEY,
  MESSAGING_API_CLIENT_SECRET,
} from '../../utils/config'
import { useRef } from 'react'
import { isEqual } from 'lodash'

export const objectToQueryString = (obj, options = {}) =>
  queryString.stringify(obj, {
    arrayFormat: 'bracket',
    skipEmptyString: true,
    ...options,
  })

export const messagingApiConfig = {
  headers: (contentType) => ({
    'content-type': contentType,
    Accept: 'application/json',
    'client-key': MESSAGING_API_CLIENT_KEY,
    'client-secret': MESSAGING_API_CLIENT_SECRET,
    ...(hp.getCookie('user_token')
      ? { Authorization: `Bearer ${hp.getCookie('user_token')}` }
      : {}),
  }),
  error: {
    code: 'INTERNAL_ERROR',
    message:
      'Something went wrong. Please check your internet connection or contact our support.',
    status: 503,
    data: {},
  },
}

export const peopleApiConfig = {
  headers: (contentType) => ({
    // Only set content-type when explicitly provided. When undefined (e.g. for FormData
    // uploads), omitting it lets Axios inject "multipart/form-data; boundary=..." automatically.
    ...(contentType !== undefined ? { 'content-type': contentType } : {}),
    Accept: 'application/json',
    ...(hp.getCookie('user_token')
      ? { 'x-access-token': hp.getCookie('user_token') }
      : {}),
  }),
}

export const contentApiConfig = {
  headers: (contentType) => ({
    'content-type': contentType,
    Accept: 'application/json',
    ...(hp.getCookie('user_token')
      ? { Authorization: `Bearer ${hp.getCookie('user_token')}` }
      : {}),
  }),
}

const useDeepMemo = (value) => {
  const valueRef = useRef()
  if (!isEqual(value, valueRef.current)) {
    valueRef.current = value
  }
  return valueRef.current
}

export { useDeepMemo }
